import { createApp } from 'vue'
import FormInputCvrField from './FormInputCvrField'

const el = '.kb-component--form-input-cvr-field'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((FormInputCvrFieldDOM) => {
            const props = {
                type: FormInputCvrFieldDOM.dataset.type,
                tooltipText: FormInputCvrFieldDOM.dataset.tooltiptext,
                errorMessageLabel:
                    FormInputCvrFieldDOM.dataset.errormessagelabel,
                helpMessageLabel: FormInputCvrFieldDOM.dataset.helpmessagelabel,
                placeholder: FormInputCvrFieldDOM.dataset.placeholder,
                label: FormInputCvrFieldDOM.dataset.label,
                isRequired: !!(
                    FormInputCvrFieldDOM.dataset.isrequired === 'true'
                ),
                fieldName: FormInputCvrFieldDOM.dataset.fieldname
            }
            const component = createApp(FormInputCvrField, props).use(Store)
            component.mount(FormInputCvrFieldDOM)
        })
    }
}
